import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useSettings } from "@/context/SettingsContext";

export const PublicLayout = ({ children }) => {
  const { settings } = useSettings();
  const { pathname } = useLocation();

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-[#F6F8FC]">
      {settings?.announcement ? (
        <div className="bg-[#1E63D6] px-4 py-2 text-center text-sm font-semibold text-white" data-testid="site-announcement">
          {settings.announcement}
        </div>
      ) : null}
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};
